<template>
  <div class="modal-mask">
    <div class="screen"></div>
    <div class="modal-wrapper">
      <div class="contentForm">
        <img src="@/assets/images/close-modal.png" class="close-button" @click="e => $emit('close')">
        <div class="content">
          <h4 class="main-title">Tu as débloqué de nouveaux badges !</h4>

          <carousel :perPage="1" paginationActiveColor="#de2128" :navigationEnabled="false" paginationColor="#ccc" :paginationSize="15" v-model="currentSlide">
            <slide class="badge-container" v-for="(badge,index) of unseenBadges">
              <img class="badge" :src="require(`@/assets/images/badges/${BadgesDB[badge].image}`)" alt="" title=""/>
              <div class="infos">
                <h4>{{ BadgesDB[badge].name }}</h4>
                <p>{{ BadgesDB[badge].description }}</p>
                <p>Tu as débloqué de nouveaux accessoires pour ton avatar !</p>
                <a class="button btnPush" @click="acceptBadge">
                  <template v-if="index !== unseenBadges.length - 1">Découvre ton badge suivant</template>
                  <template v-else>Retourner sur mon carnet de bord</template>
                </a>
              </div>
            </slide>
          </carousel>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import Bouton from '@/components/Bouton'
  import MouseTrap from '@/components/MouseTrap'
  import { Carousel, Slide } from 'vue-carousel'
  import BadgesDB from '@/datas/badges.json'

  export default {
    components: { MouseTrap, Bouton, Carousel, Slide },
    data () {
      return {
        identifier: '',
        password: '',
        errors: [],
        currentSlide: 0
      }
    },
    methods: {
      ...mapActions(['resetNotificationsCount']),
      async acceptBadge () {
        if (this.currentSlide < this.unseenBadges.length - 1) {
          this.currentSlide = this.currentSlide += 1
        } else {
          await this.resetNotificationsCount()
          this.$router.push({name: 'dashboard'})
        }
      }
    },
    computed: {
      ...mapState([ 'unseenBadges']),
      BadgesDB() {
        return BadgesDB
      }
    }
  }
</script>

<style scoped lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper { width: 100%;display: table-cell; vertical-align: middle; position: relative; }
.modal-enter { opacity: 0; }
.modal-leave-active {  opacity: 0; }

.modal-enter .contentForm,
.modal-leave-active .contentForm {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.close-button {
  position: absolute;
  left: -20px;
  top: -20px;
  cursor: pointer;
}

.contentForm {
  width: 100%;
  max-width: 700px;
  margin: 0 0 0 -350px;
  left: 50%;
  top: 200px;
  color: #fff;
  font-family: 'blogger_sansregular';
  text-align: center;
  background: #fff;
  position: absolute;
  border-radius: 30px;
  padding: 20px;
  z-index: 100;
  -webkit-transition: all 0.6s ease;
  -moz-transition: all 0.6s ease;
  -o-transition: all 0.6s ease;
  transition: all 0.6s ease;
}

.contentForm:before {
  content: '';
  width: 275px;
  height: 180px;
  display: block;
  background: transparent url('~@/assets/images/mascotte-badge.png') no-repeat 0 0;
  position: absolute;
  top: -110px;
  right: -20px;
}

.open .contentForm {
  top: 10%;
  position: fixed;
}

.contentForm .content {
  width: 100%;
  border-radius: 30px;
  padding: 30px;
  box-shadow: 5px 5px 25px rgba(0,0,0,0.4);
  text-align: left;
}
.contentForm .content .badge {
  display: inline-block;
  max-width: 25%;
  margin-right: 5%;
  float: left;
}
.contentForm .content .infos {
  display: inline-block;
  max-width: 69%;
}

.contentForm .content h4 {
  color: #413492;
  font-size: 24px;
}
.contentForm .content h4.main-title {
  text-align: center;
  font-size: 28px;
  margin-bottom: 40px;
}
.contentForm .content p {
  color: #686868;
  font-size: 18px;
  font-family: 'blogger_sansregular';
}

.screen {
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgba(0,0,0,0.1);
  z-index: 100;
  top: 0;
}

.lost {
  display: inline-block;
  width: 100%;
  float: left;
  margin: 0px 0 10px;
  text-align: left;
  color: #de2128;
  font-family: 'blogger_sansbold';
  text-indent: 0px;
  -webkit-transition: all 0.6s ease;
  -moz-transition: all 0.6s ease;
  -o-transition: all 0.6s ease;
  transition: all 0.6s ease;
}
// .badge-container {
//   min-height: 150px;
//   margin-bottom: 10px;
// }
.center {
  text-align: center;
}
.lost:hover { text-decoration: underline; text-indent: 20px;}

@media (max-width: 740px) {

  .contentForm .content { max-width: 100%; text-align: center;    padding: 30px 5px;}
  .contentForm .content .badge {    max-width: 40%; margin-right: 0%;float: inherit; clear: both;}
  .contentForm[data-v-15fc1aaa] {  max-width: 80%; margin: 0 0 0 -40%; }
  .contentForm .content h4 {font-size: 18px;}

}

@media (max-width: 400px) {

  .contentForm  { top: 100px; }

}

</style>
